<div class="st-page">
  <div class="st-page-head">
    <div>
      <h1 class="st-title">{{ 'myTimetable' | translate }}</h1>
      <p class="st-subtitle">{{ 'yourWeeklyScheduleAcrossAllClasses' | translate }}</p>
    </div>
  </div>

  <!-- Week day chip strip -->
  <div class="sct-week-row">
    <ng-container *ngIf="!loading">
      <div class="sct-day-chip" *ngFor="let d of weekDays"
           [class.active]="selectedDay.dayName === d.dayName"
           [class.is-today]="d.isToday && selectedDay.dayName !== d.dayName"
           (click)="selectDay(d)">
        <span class="sct-day-name">{{ d.shortLabel }}</span>
      </div>
    </ng-container>
    <ng-container *ngIf="loading">
      <div class="sct-day-chip sct-skeleton" *ngFor="let i of [1,2,3,4,5,6,7]"></div>
    </ng-container>
  </div>

  <!-- Loading skeleton -->
  <div class="sct-timeline-scroll" *ngIf="loading">
    <div class="sct-skeleton sct-skeleton-row" *ngFor="let i of [1,2,3,4,5,6]"></div>
  </div>

  <!-- Error -->
  <div class="st-empty-state" *ngIf="!loading && loadError">
    <i class="ri-error-warning-line"></i>
    {{ 'unableToLoadYourTimetablePleaseTryAgain' | translate }}
  </div>

  <!-- Timeline -->
  <div class="sct-timeline-scroll" id="smt-timeline-scroll" *ngIf="!loading && !loadError">
    <div class="sct-timeline" [style.height.px]="totalHeight">
      <!-- Hour grid -->
      <div class="sct-hour-row" *ngFor="let top of hourTops; let i = index" [style.top.px]="top">
        <span class="sct-hour-label" *ngIf="i < 24">{{ hourLabel(i) }}</span>
        <div class="sct-hour-line"></div>
      </div>

      <!-- Now line -->
      <div class="sct-now-line" *ngIf="showNowLine" [style.top.px]="nowOffset">
        <span class="sct-now-badge">{{ currentTimeLabel }}</span>
      </div>

      <!-- Period cards -->
      <div class="sct-period-card"
           *ngFor="let p of periods"
           [class.is-past]="isPast(p)"
           [class.is-current]="isCurrent(p)"
           [style.top.px]="p.top"
           [style.height.px]="p.height"
           [style.left]="'calc(56px + (100% - 68px) * ' + (p.left / 100) + ')'"
           [style.width]="'calc((100% - 68px) * ' + (p.width / 100) + ')'">
        <div class="sct-period-time">{{ p.periodStart }} - {{ p.periodEnd }}</div>
        <div class="sct-period-title">{{ p.title }}</div>
        <div class="sct-period-subtitle" *ngIf="p.subtitle">{{ p.subtitle }}</div>
      </div>

    </div>
  </div>
</div>
